(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-slide-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.slide_right_box .slider-item');
    const leftBox = document.querySelector('.slide_left_box');

    if (items.length > 0 && leftBox) {
      function activate(item) {
        items.forEach(function (el) {
          el.classList.remove('active');
          el.setAttribute('aria-selected', 'false');
          el.setAttribute('tabindex', '-1');
        });
        item.classList.add('active');
        item.setAttribute('aria-selected', 'true');
        item.setAttribute('tabindex', '0');

        const index = item.getAttribute('data-index');
        leftBox.classList.forEach(function (cls) {
          if (cls.startsWith('active_index_')) {
            leftBox.classList.remove(cls);
          }
        });
        leftBox.classList.add('active_index_' + index);
      }

      items.forEach(function (item) {
        // Mouse / touch
        item.addEventListener('click', function () {
          activate(this);
        });

        // Keyboard support (WCAG 2.1.1): Enter/Space activates the focused
        // tab; arrow keys, Home and End move focus following the standard
        // ARIA tabs pattern.
        item.addEventListener('keydown', function (event) {
          const list = Array.from(items);
          const currentIndex = list.indexOf(this);
          let nextIndex = -1;

          switch (event.key) {
            case 'Enter':
            case ' ':
              event.preventDefault();
              activate(this);
              return;
            case 'ArrowDown':
            case 'ArrowRight':
              nextIndex = (currentIndex + 1) % list.length;
              break;
            case 'ArrowUp':
            case 'ArrowLeft':
              nextIndex = (currentIndex - 1 + list.length) % list.length;
              break;
            case 'Home':
              nextIndex = 0;
              break;
            case 'End':
              nextIndex = list.length - 1;
              break;
            default:
              return;
          }

          if (nextIndex > -1) {
            event.preventDefault();
            const target = list[nextIndex];
            activate(target);
            target.focus();
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
